// src/components/Popups/Settings/PolygonLessonsSetting.jsx
//
// Setări (doar admin) → Lecții pe poligon: câte din lecțiile practice ale cursului se fac pe
// poligon (elevii din sectoarele fără poligon le fac primele). Schimbarea se
// aplică doar elevilor noi: fiecare elev își păstrează numărul fixat la prima
// programare.

import React, { useCallback, useEffect, useState } from "react";

import {
   getBookingSettings,
   updateBookingSettings,
} from "../../../api/settingsService";
import { ButtonUI, InputUI, StatusUI } from "../../UI";

export default function PolygonLessonsSetting() {
   const [settings, setSettings] = useState(null);
   const [draft, setDraft] = useState("");
   const [busy, setBusy] = useState(false);
   const [feedback, setFeedback] = useState(null);

   const load = useCallback(() => {
      setFeedback(null);
      getBookingSettings()
         .then((data) => {
            setSettings(data);
            setDraft(String(data?.polygonLessons ?? ""));
         })
         .catch((err) => setFeedback({ ok: false, text: err?.message }));
   }, []);

   useEffect(() => {
      load();
   }, [load]);

   const total = Number(settings?.totalLessons) || 30;
   const value = Number(draft);
   const valid = draft.trim() !== "" && Number.isInteger(value) && value >= 0 && value <= total;
   const dirty = settings && String(settings.polygonLessons) !== draft.trim();

   const save = async () => {
      setBusy(true);
      setFeedback(null);
      try {
         const data = await updateBookingSettings(value);
         setSettings(data);
         setDraft(String(data?.polygonLessons ?? value));
         setFeedback({ ok: true, text: "Salvat. Se aplică elevilor care se programează de acum înainte." });
      } catch (err) {
         setFeedback({ ok: false, text: err?.message });
      } finally {
         setBusy(false);
      }
   };

   return (
      <div className="appearancePopup__stack">
         {!settings && !feedback && <StatusUI tone="loading" />}

         {settings && (
            <>
               <InputUI
                  type="number"
                  label="Lecții pe poligon"
                  min={0}
                  max={total}
                  step={1}
                  value={draft}
                  disabled={busy}
                  onChange={(e) => setDraft(e.target.value)}
                  after={<span className="appearancePopup__unit">din {total}</span>}
                  error={
                     !valid && draft.trim() !== ""
                        ? `Alege un număr între 0 și ${total}.`
                        : undefined
                  }
               />
               <ButtonUI.Row align="end">
                  <ButtonUI
                     variant="primary"
                     loading={busy}
                     disabled={!dirty || !valid || busy}
                     onClick={save}
                  >
                     Salvează
                  </ButtonUI>
               </ButtonUI.Row>
            </>
         )}

         {feedback?.text && (
            <StatusUI tone={feedback.ok ? "success" : "error"}>{feedback.text}</StatusUI>
         )}
      </div>
   );
}
